export enum FeeAndTaxes {
  ProvideOption = 1,
  PassAutomatically = 2
}